import { isPermalinkPath } from '@/features/seo-listing/consts';

/** Address-bar path (pushState-aware), not Next.js usePathname(). */
export const getBrowserPathname = (): string => window.location.pathname;

export const isOnPermalinkRoute = (): boolean => isPermalinkPath(getBrowserPathname());
